<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Tag` }}
            </h4>
            <v-form ref="tagForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="tagModel.name"
                    label="Tag Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'Tag Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { Tag } from "@/models/Tag";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      tagModel: new Tag(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Tags",
          disabled: false,
          href: "/admin/tags",
        },
        {
          text: "Tag Detail",
          disabled: false,
          href: `/admin/tags/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Tag`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    tag: {
      query: gql`
        query Tag($id: ID!) {
          tag(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.tagModel.id = this.tag.id;
        this.tagModel.name = this.tag.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.tagForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateTag()
          .then(() => {
            this.$swal("Success!", "Tag was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the tag, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createTag()
          .then(() => {
            this.$swal("Success!", "Tag was created", "success");
            window.location.href = `/admin/tags/${self.tagModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the tag, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateTag() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($tag: TagUpdateInput!) {
              updateTag(tag: $tag) {
                id
                updated
              }
            }
          `,
          variables: {
            tag: {
              id: self.tagModel.id,
              name: self.tagModel.name,
              updatedBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the tag!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createTag() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createTag($tag: TagCreateInput!) {
              createTag(tag: $tag) {
                id
              }
            }
          `,
          variables: {
            tag: {
              name: self.tagModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Tag Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createTag) {
          self.tagModel.id = response?.data?.createTag?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
